import styled from "styled-components";
import { ptToVwConverter, mobileVwConverter } from "../../utils";
import { Button } from "@material-ui/core";

// general

export const NewsContainer = styled.div`
  height: 100%;
  min-height: 100%;
  margin-top: ${ptToVwConverter(116)}vw;
  margin-left: ${ptToVwConverter(313)}vw;
  margin-right: ${ptToVwConverter(313)}vw;
  padding: 0;
  @media (max-width: 1024px) {
    height: auto;
    margin: ${mobileVwConverter(120)}vw ${mobileVwConverter(50)}vw 0
      ${mobileVwConverter(50)}vw;
  }
`;

// list page

export const NewsMain = styled.main`
  width: 100%;
  @media (min-width: 1024px) {
    display: block;
    height: auto;
    min-height: 545px;
    margin-left: ${ptToVwConverter(26)}vw;
  }
  @media (max-width: 1024px) {
    padding-top: ${mobileVwConverter(28)}vw;
  }
`;

export const LinkButton = styled(Button)`
  && {
    padding: 0;
    display: block;
    text-align: left;
    line-height: unset;
    text-transform: unset;
    border-radius: 0;
    margin-bottom: ${ptToVwConverter(40)}vw;

    @media (max-width: 1024px) {
      width: 100%;
      margin-top: ${mobileVwConverter(30)}vw;
      margin-bottom: ${mobileVwConverter(50)}vw;
    }
  }
`;

export const LinkInsideContainer = styled.div`
  @media (min-width: 1024px) {
    display: flex;
  }
`;

export const NewsPhoto = styled.img`
  border: solid 1px #d4d4d4;
  width: ${ptToVwConverter(270)}vw;
  height: ${ptToVwConverter(180)}vw;
  @media (max-width: 1024px) {
    width: ${mobileVwConverter(300)}vw;
    height: ${mobileVwConverter(200)}vw;
  }
`;

export const NewsPhotoAlt = styled.div`
  border: solid 1px #d4d4d4;
  min-width: ${ptToVwConverter(270)}vw;
  height: ${ptToVwConverter(180)}vw;
`;

export const TextContainer = styled.div`
  @media (min-width: 1024px) {
    margin-left: ${ptToVwConverter(30)}vw;
    width: 100%;
  }
  @media (max-width: 1024px) {
    margin: ${mobileVwConverter(25)}vw 0;
  }
`;

export const NewsSmallTitle = styled.div`
  letter-spacing: 0.1em;
  color: black;
  font-size: 16px;
  margin-top: 0;
  margin-bottom: ${ptToVwConverter(6)}vw;
  @media (max-width: 1024px) {
    margin-bottom: ${mobileVwConverter(6)}vw;
  }
`;

export const NewsText = styled.div`
  font-size: 12px;
  letter-spacing: 0.1em;
  color: #808080;
  margin-bottom: ${ptToVwConverter(2)}vw;
  @media (max-width: 1024px) {
    margin-bottom: ${mobileVwConverter(2)}vw;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  margin-top: ${ptToVwConverter(60)}vw;
  justify-content: center;
  @media (max-width: 1024px) {
    margin-top: ${mobileVwConverter(70)}vw;
  }
`;

// [id]

export const RightContainer = styled.main`
  height: auto;
  width: 100%;
  display: block;
  margin-left: ${ptToVwConverter(26)}vw;
  min-height: 545px;
  @media (max-width: 1024px) {
    margin-left: 0;
    margin-top: ${mobileVwConverter(60)}vw;
  }
`;

export const Title = styled.div`
  margin-bottom: ${ptToVwConverter(14)}vw;
  color: black;
  font-size: 20px;
  letter-spacing: 0.1em;
  @media (max-width: 1024px) {
    margin-bottom: ${mobileVwConverter(40)}vw;
  }
`;

export const SubTitle = styled.div`
  margin-bottom: ${ptToVwConverter(2)}vw;
  color: #808080;
  font-size: 14px;
  letter-spacing: 0.1em;
  @media (max-width: 1024px) {
    margin-bottom: ${mobileVwConverter(5)}vw;
  }
`;

export const MainImage = styled.img`
  width: ${ptToVwConverter(343)}vw;
  height: ${ptToVwConverter(228)}vw;
  border: solid 1px #d4d4d4;
`;

export const BodyWrapper = styled.div`
  margin-bottom: ${ptToVwConverter(40)}vw;
  color: #4d4d4d;
  font-size: 14px;
  letter-spacing: 0.1rem;
  line-height: 2.8em;
  @media (max-width: 1024px) {
    margin-top: ${mobileVwConverter(60)}vw;
    letter-spacing: 0.05rem;
  }
`;

export const SubImage = styled.img`
  border: solid 1px #d4d4d4;
  width: 100%;
`;

// letter-spacing: 0.1rem;

// pagination

export const PaginationMain = styled.div`
  margin: 0 5px;
  height: 40px;
  width: 110px;
  background-color: black;
  color: white;
  letter-spacing: 0.1rem;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 1024px) {
    height: 33px;
    width: 130px;
  }
`;

export const GoListButton = styled(Button)`
  && {
    margin: 0 5px;
    height: 40px;
    min-width: 150px;
    background-color: black;
    color: white;
    letter-spacing: 0.1rem;
    border-radius: 0;
    font-size: 11.2px;
    &:hover {
      background-color: black;
    }
    @media (max-width: 1024px) {
      height: 33px;
      min-width: 130px;
    }
  }
`;

export const PreviousNextButton = styled(Button)`
  && {
    height: 40px;
    min-width: 40px;
    background-color: black;
    color: white;
    border-radius: 0;
    font-size: 11.2px;
    &:hover {
      background-color: black;
    }
    @media (max-width: 1024px) {
      height: 33px;
      min-width: 33px;
    }
  }
`;

// back to list

export const BackToListWrapper = styled.div`
  display: flex;
  margin-top: 30px;
  margin-bottom: 170px;
  @media (max-width: 1024px) {
    justify-content: center;
    margin-bottom: 0;
  }
`;
